import React, { Fragment } from 'react';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import AdditionalInformationSummary from './pageIncludes/summary/AdditionalInformationSummary';
import PageHeader from '../headers/PageHeader';

// Selectors

import { selectIfRenewalFlow } from '../../../reducers/appReducer';



/**
 *
 * @param {Object} props
 * @returns {React.Component} - Summary page for 'Family and Household' Section
 *
 */
const Page4_64  = props => {

    const {
        adjustedFlow,
        data,
        environment: {
            isState,
            localDates: {
                serverDate
            }
        },
        householdMembers,
        taxHousehold
    } = props;

    const {
        buttonContainer,
        itfFeatureEnabled
    } = props;

    const isRenewalFlow = useSelector(selectIfRenewalFlow);

    return (
        <Fragment>
            <div id="fhSummary" className="fade-in ">
                <div className="subsection">
                    <PageHeader
                        text='ssap.subheader.review_and_confirm'
                        headerClassName={'gi-heading-alt'}
                    />
                    <div className="grid-row">
                        <div className="usa-alert usa-alert-info gi-alert gi-alert__info alert__review">
                            <div className="usa-alert-body gi-alert__info__body">
                                <p className="usa-alert-text gi-alert__info__text">
                                    <FormattedMessage id='ssap.additional_info.summary.notification'/>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div  className="grid-row">
                        <AdditionalInformationSummary
                            {...{
                                adjustedFlow,
                                buttonContainer,
                                householdMembers,
                                isRenewalFlow,
                                isState,
                                itfFeatureEnabled,
                                previousData: data,
                                serverDate,
                                taxHousehold
                            }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,

    adjustedFlow: state.ssap.adjustedFlow,
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember,

    taxHousehold: state
        .ssap
        .data
        .taxHousehold
});

export default connect(mapStateToProps)(Page4_64);
